/* eslint-disable max-len */
import { memo } from 'react';

function SadIcon() {
  return (
    <svg
      width="81"
      height="80"
      viewBox="0 0 81 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.4202 58.8565C9.00575 48.442 9.00575 31.5572 19.4202 21.1427L19.9462 20.6307C30.3935 10.7333 46.8907 10.9039 57.1321 21.1429C65.1948 29.2079 66.9176 40.8139 61.9975 50.9049L61.7492 51.3956L64.8764 63.9061C65.2765 65.5065 63.8637 66.9375 62.2989 66.6277L62.0633 66.5679L51.8647 63.4089L51.4996 63.6086C41.4141 68.8624 28.2743 67.2325 19.9351 59.3568L19.4202 58.8565ZM57.441 50.0391C62.2205 41.368 60.9725 31.2707 53.9893 24.2855C45.3105 15.6087 31.2396 15.6087 22.5629 24.2853C13.8841 32.9642 13.8841 47.0349 22.5629 55.7138C29.7541 62.905 41.7718 64.2613 50.4749 59.0943C51.0153 58.7735 51.6663 58.6964 52.2666 58.8823L59.6047 61.1556L57.2313 51.6507C57.1179 51.197 57.151 50.7216 57.3219 50.2913L57.441 50.0391ZM45.5936 29.5398C46.4614 28.6719 47.8684 28.6719 48.7363 29.5398C49.5374 30.3408 49.599 31.6013 48.9211 32.4731L48.7363 32.6825L41.4187 40L48.7363 47.3175C49.6041 48.1854 49.6041 49.5924 48.7363 50.4602C47.9352 51.2613 46.6747 51.3229 45.8029 50.6451L45.5936 50.4602L38.276 43.1427L30.9585 50.4602C30.0907 51.3281 28.6836 51.3281 27.8158 50.4602C27.0147 49.6592 26.9531 48.3986 27.6309 47.5269L27.8158 47.3175L35.1333 40L27.8158 32.6825C26.948 31.8146 26.948 30.4076 27.8158 29.5398C28.6169 28.7387 29.8774 28.6771 30.7492 29.3549L30.9585 29.5398L38.276 36.8573L45.5936 29.5398Z"
        fill="#191414"
      />
    </svg>
  );
}

export default memo(SadIcon);
